var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 14.41V10.24C8 9.82 8.35 9.43 8.77 9.43H11.29V7.35C11.29 2.51 13.77 0.04 18.71 0C20.36 0 21.93 0.21 23.4 0.64C23.86 0.78 24.03 1.06 24 1.52L23.44 5.58C23.4 5.76 23.3 5.93 23.12 6.11C22.91 6.22 22.7 6.29 22.49 6.25C21.61 6 20.71 5.9 19.69 5.9C18.29 5.9 18.08 6.18 18.08 7.63V9.43H22.6C23.02 9.43 23.41 9.85 23.41 10.31L23.06 14.48C23.06 14.9 22.71 15.19 22.29 15.19H18.08V31.19C18.08 31.61 17.73 32 17.31 32H12.1C11.68 32 11.3 31.61 11.3 31.19V15.19H8.78C8.57313 15.19 8.37473 15.1078 8.22846 14.9615C8.08218 14.8153 8 14.6169 8 14.41","fill":"black"}));
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
